import axios from 'axios'

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data)
    } else {
        reject(error)
    }
}

export default {
    dashboard(params) {
        return new Promise(async (resolve, reject) => {
            try {
                // console.log('params : ', params)
                const { data } = await axios.get('/customers', { params })
                resolve(data)
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'name', 'code'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/customers/list${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },    
    insert(data) {
        return new Promise(async (resolve, reject) => {
            try {
                // console.log('data', data)
                const resp = await axios.post('/customers', data)
                resolve(resp)
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    update(data) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.put(`/customers/${data.customer_id}`, data)
                resolve(resp)
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/customers/${obj.customer_id}`)
                resolve(resp)
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

    exportxls() {
        return new Promise((resolve, reject) => {
            try {
                axios({
                    url: `/customers/exportxls`,
                    method: 'GET',
                    responseType: 'blob' // important
                }).then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'customer_list.xlsx')
                    document.body.appendChild(link)
                    link.click()
                    // window.location.assign(url)
                    resolve(link)
                })
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    }
}
